/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({
    "data": {
      "categories": {
        "cardinal": ["one", "other"],
        "ordinal": ["other"]
      },
      "fn": function fn(n, ord) {
        var s = String(n).split('.'),
          t0 = Number(s[0]) == n;
        if (ord) return 'other';
        return n == 0 || n == 1 || t0 && n >= 11 && n <= 99 ? 'one' : 'other';
      }
    },
    "locale": "tzm"
  });
}